// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"SupplierWiseCurrencySalesPage_inputContainer__2f1q3"};